(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();

    this.header = null;
    this.headerBounds = {
      top: 0,
      bottom: 0
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.scrollTicking = false;
    this.resizeTicking = false;
    this.isScrolling = null;
    this.resizeObserver = null;
    this.intersectionObserver = null;
  }

  connectedCallback() {
    this.header = this.closest('.section-header');

    if (!this.header) {
      return;
    }

    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';

    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.queueScroll.bind(this);
    this.onResizeHandler = this.queueResize.bind(this);
    this.hideHeaderOnScrollUp = () => {
      this.preventReveal = true;
    };

    this.setHeaderHeight();
    this.updateHeaderBounds();

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.addEventListener(
      'preventHeaderReveal',
      this.hideHeaderOnScrollUp
    );

    window.addEventListener(
      'scroll',
      this.onScrollHandler,
      {
        passive: true
      }
    );

    window.addEventListener(
      'resize',
      this.onResizeHandler
    );

    this.createHeaderObserver();
    this.createResizeObserver();
  }

  disconnectedCallback() {
    this.removeEventListener(
      'preventHeaderReveal',
      this.hideHeaderOnScrollUp
    );

    window.removeEventListener(
      'scroll',
      this.onScrollHandler
    );

    window.removeEventListener(
      'resize',
      this.onResizeHandler
    );

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }

    if (this.isScrolling) {
      window.clearTimeout(this.isScrolling);
    }
  }

  setHeaderHeight() {
    if (!this.header) {
      return;
    }

    document.documentElement.style.setProperty(
      '--header-height',
      `${this.header.offsetHeight}px`
    );
  }

  updateHeaderBounds() {
    if (!this.header) {
      return;
    }

    const rect = this.header.getBoundingClientRect();

    this.headerBounds = {
      top: rect.top + window.scrollY,
      bottom: rect.bottom + window.scrollY
    };
  }

  queueResize() {
    if (this.resizeTicking) {
      return;
    }

    this.resizeTicking = true;

    requestAnimationFrame(() => {
      this.setHeaderHeight();
      this.updateHeaderBounds();
      this.resizeTicking = false;
    });
  }

  queueScroll() {
    if (this.scrollTicking) {
      return;
    }

    this.scrollTicking = true;

    requestAnimationFrame(() => {
      this.onScroll();
      this.scrollTicking = false;
    });
  }

  createHeaderObserver() {
    if (!('IntersectionObserver' in window)) {
      return;
    }

    this.intersectionObserver = new IntersectionObserver(
      entries => {
        const entry = entries[0];

        if (!entry) {
          return;
        }

        const rect = entry.boundingClientRect;

        this.headerBounds = {
          top: rect.top + window.scrollY,
          bottom: rect.bottom + window.scrollY
        };
      },
      {
        threshold: [0, 1]
      }
    );

    this.intersectionObserver.observe(this.header);
  }

  createResizeObserver() {
    if (!('ResizeObserver' in window)) {
      return;
    }

    this.resizeObserver = new ResizeObserver(() => {
      this.queueResize();
    });

    this.resizeObserver.observe(this.header);
  }

  onScroll() {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop;

    if (
      this.predictiveSearch &&
      this.predictiveSearch.isOpen
    ) {
      this.currentScrollTop = scrollTop;
      return;
    }

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add(
        'scrolled-past-header'
      );

      if (!this.preventHide) {
        this.hide();
      }
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add(
        'scrolled-past-header'
      );

      if (!this.preventReveal) {
        this.reveal();
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = window.setTimeout(
          () => {
            this.preventReveal = false;
          },
          66
        );

        this.hide();
      }
    } else if (
      scrollTop <= this.headerBounds.top
    ) {
      this.header.classList.remove(
        'scrolled-past-header'
      );

      this.reset();
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) {
      return;
    }

    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky'
    );

    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) {
      return;
    }

    this.header.classList.add(
      'shopify-section-header-sticky',
      'animate'
    );

    this.header.classList.remove(
      'shopify-section-header-hidden'
    );
  }

  reset() {
    if (this.headerIsAlwaysSticky) {
      return;
    }

    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );
  }

  closeMenuDisclosure() {
    if (!this.disclosures) {
      this.disclosures =
        this.header.querySelectorAll('header-menu');
    }

    this.disclosures.forEach(disclosure => {
      if (
        disclosure &&
        typeof disclosure.close === 'function'
      ) {
        disclosure.close();
      }
    });
  }

  closeSearchModal() {
    if (!this.searchModal) {
      this.searchModal =
        this.header.querySelector('details-modal');
    }

    if (
      this.searchModal &&
      typeof this.searchModal.close === 'function'
    ) {
      this.searchModal.close(false);
    }
  }
}

if (!customElements.get('sticky-header')) {
  customElements.define(
    'sticky-header',
    StickyHeader
  );
}

  } catch(e) { console.error(e); }
})();
})();
